import React, { useState, useCallback } from 'react';
import styled from 'styled-components';

import media from '../style/media';
import { Flex } from './shared/Flex';
import { Menu, X } from 'lucide-react';

const Wrapper = styled(Flex)`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  justify-content: space-between;
  align-items: center;
  min-height: 80px;
  z-index: 100;
  background: rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding: 0 1.5rem;
  box-sizing: border-box;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);

  ${media.tablet`
    padding: 0 3.5rem;
  `}
`;

// Cleaned up NavItems since it's empty now, but keeping the structure for Logo alignment or future adds
const TopBar = ({ onSettingsClick, isMeasuring }: any) => {
  return (
    <Wrapper>
      {/* Logo removed */}
    </Wrapper>
  );
};



export default TopBar;
